/**
 * orgContext.ts — общий детектор «организационного» адреса (случай PM 10.08).
 *
 * Панель (Sidebar) определяет режим меню по адресу страницы (WEB-438: URL —
 * источник правды). Подпись в шапке и переключатель проектов читали только
 * сохранённый проект — и на орг-страницах показывали проект, пока панель
 * рядом честно показывала орг-меню. Два источника правды на одном экране.
 * Детектор один на всех: орг-адреса объявлены здесь, потребители не могут
 * разъехаться.
 */

/** Верхние адреса организационного контура (совпадает с орг-меню панели). */
export const ORG_TOP_LEVEL_PATHS = [
  '/org/dashboard',
  '/projects',
  '/org/balance',
  '/org/domains',
  '/org/audit',
] as const;

export function isOrgTopLevelPath(pathname: string): boolean {
  return ORG_TOP_LEVEL_PATHS.some((p) => pathname.startsWith(p));
}
